import React, { useEffect, useRef } from "react";
import AliceCarousel from "react-alice-carousel";
import classNames from "classnames";

import { FormattedMessage } from '../../util/reactIntl';
import { IconCarouselArrows, MasonryPopup } from '../../components';

import css from "./CMSPageCarousel.module.css";

const CMSPageCarousel = (props) => {
  const { blocks, onManageDisableScrolling } = props;
  if (!blocks?.length) return null;

  const playersRef = useRef([]);

  useEffect(() => {
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }

    window.onYouTubeIframeAPIReady = () => {
      blocks.forEach((block, index) => {
        if (block?.media?.fieldType === "youtube") {
          const id = `youtube-player-${index}`;
          playersRef.current[index] = new window.YT.Player(id, {});
        }
      });
    };
  }, [blocks]);

  const carouselItems = blocks.map((block, index) => {
    const { media, title, text, blockName } = block;
    const isVideo = media?.fieldType === "youtube";
    let mediaContent = null;

    if (isVideo && media.youtubeVideoId) {
      mediaContent = (
        <div className={css.videoContainer}>
          <iframe
            id={`youtube-player-${index}`}
            src={`https://www.youtube.com/embed/${media.youtubeVideoId}?enablejsapi=1`}
            title={blockName || `Video ${index + 1}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className={css.video}
          />
        </div>
      );
    } else {
      const variants = media?.image?.attributes?.variants || {};
      const imageUrl =
        variants.landscape800?.url ||
        variants.landscape1200?.url ||
        variants.landscape400?.url;
      const alt = media?.alt || blockName || `Image ${index + 1}`;
      mediaContent = <img src={imageUrl} alt={alt} className={css.image} />;
    }

    return (
      <div key={index} className={css.cardHolder}>
        {mediaContent && (
          <div className={css.mediaContainer}>{mediaContent}</div>
        )}
        {(title?.content || text?.content) && (
          <div className={css.contentContainer}>
            {title?.content && <h3 className={css.title}>{title.content}</h3>}
            {text?.content && <div className={css.text}>{text.content}</div>}
          </div>
        )}
      </div>
    );
  });

  const handlePauseAll = () => {
    playersRef.current.forEach((p) => {
      if (p && typeof p.pauseVideo === "function") {
        p.pauseVideo();
      }
    });
  };

  const prevButton = () => (
    <button className={css.prevButton} type="button">
      <IconCarouselArrows type="black-left" />
    </button>
  );

  const nextButton = () => (
    <button className={css.nextButton} type="button">
      <IconCarouselArrows type="black-right" />
    </button>
  );

  return (
    <div className={classNames(css.root)}>
      <div className={css.carouselHolder}>
        <AliceCarousel
          className={css.carousel}
          items={carouselItems}
          infinite
          slideBy={1}
          renderPrevButton={prevButton}
          renderNextButton={nextButton}
          onSlideChanged={({ item }) => handlePauseAll()}
        />
      </div>

      <div className={css.openGalleryHolder}>

        <MasonryPopup
          id="CMSPageCarouselGallery"
          items={carouselItems}
          buttonClass={css.openGallery}
          buttonText={<FormattedMessage id="CustomLabel.openGallery" />}
          iconType="arrow"
          onManageDisableScrolling={onManageDisableScrolling}
        // hideTopbar
        />
      </div>
    </div>
  );
};

export default CMSPageCarousel;


